import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

document.querySelectorAll('.element-processlist').forEach((el) => {
  const divider = el.querySelector('.step-divider')
  const items = el.querySelectorAll('.step-item')
  const mediaEls = el.querySelectorAll('.step-item-media-container')
  const leftEls = el.querySelectorAll('.step-item-left')
  const rightEls = el.querySelectorAll('.step-item-right')

  gsap.set(divider, { height: 0 })
  gsap.set(mediaEls, { opacity: 0, y: '50%' })
  gsap.set(leftEls, { x: '-100vw' })
  gsap.set(rightEls, { x: '100vw' })

  const common = {
    duration: 0.8,
    stagger: 0.2,
    paused: true,
    ease: 'power4',
  }

  items.forEach((item) => {
    gsap.to(item.querySelectorAll('.step-item-media-container'), {
      ...common,
      y: 0,
      opacity: 1,
      scrollTrigger: {
        trigger: item,
        start: 'top 90%',
        markers: false,
      },
      onStart: () => {
        const percentage = gsap.utils.normalize(0, items.length, item.dataset.stepIndex) * 100

        gsap.to(divider, {
          duration: 0.5,
          ease: 'power4',
          height: `${percentage}%`,
        })
      },
    })

    if (item.querySelectorAll('.step-item-left').length) {
      gsap.to(item.querySelectorAll('.step-item-left'), {
        ...common,
        x: 0,
        scrollTrigger: {
          trigger: item,
          start: 'top 90%',
          markers: false,
        },
      })
    }

    if (item.querySelectorAll('.step-item-right').length) {
      gsap.to(item.querySelectorAll('.step-item-right'), {
        ...common,
        x: 0,
        opacity: 1,
        scrollTrigger: {
          trigger: item,
          start: 'top 90%',
          markers: false,
        },
      })
    }
  })
})
